import { Suspense, useEffect, useMemo, useState } from 'react';
import { Box, Paper } from '@mui/material';
import CustomAccordion from '../../../../components/ui/materialui/customAccordion';

import { useColumns } from '../utils/columns';
import Tabla from '../../../../components/ui/materialui/tabla';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { RowEndosoMasivo } from '../models/rowEndosoMasivo';
import { MutuoSeleccionadoEndoso } from '../models/mutuoSeleccionadoEndoso';
import UseEndosoMasivo from '../hooks/useEndosoMasivo';
import { FormularioFiltroEndoso } from '../components/formularioFiltroEndoso';
import { FormularioCalculoEndoso } from '../components/formularioCalculoEndoso';
import { FiltroEndosoMasivo } from '../models/filtroEndosoMasivo';
import { CalculoEndosoMasivo } from '../models/calculoEndosoMasivo';
import { useToast } from '../../../../hooks/useToast';
import { useColumnsResultOperacion } from '../utils/columnsResultOperacion';
import { ResultOperacionEndoso } from '../models/resultOperacionEndoso';
import { ModalResultados } from '../../../../components/ui/materialui/modalResultados';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';
import { AxiosResponse } from 'axios';
import { ListResponseDto } from '../../../../dtos/ListResponseDto';
import TableHeader from '../../../../components/ui/materialui/tableHeader';
import { PermissionGuard } from '../../../../components/auth/ProtectedRoute';
import { TipoFuncionalidad } from '../../../../utils/enums';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { exportExcel } from '../../../../utils/exportExcel';
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';


export default function EndosoMasivo(){

    const { buscarEndosos, grabarEndosos } = UseEndosoMasivo();
    const { addToast } = useToast();
    const navigate = useNavigate();

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Endosos', url: `/endosos` },
        { label: 'Endoso Masivo', url: `/endosos/endosos-masivos` }
    ]

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });

    const [data, setData] = useState<RowEndosoMasivo[]>([])
    const [mutuosEndosar, setMutuosEndosar] = useState<MutuoSeleccionadoEndoso[]>([])
    const [resultadosOperacion, setResultadosOperacion] = useState<ResultOperacionEndoso[]>([]);
    const [inversionista, setInversionista] = useState<string>("");
    const [fechaEndoso, setFechaEndoso] = useState<Date>(new Date());
    const [showResult, setShowResult] = useState<boolean>(false);

    const { COLUMNS } = useColumns({ mutuosEndosar, data, setMutuosEndosar, fechaEndoso, inversionista  });
    const { COLUMNS_RESULT } = useColumnsResultOperacion();

    const columns = useMemo(() => COLUMNS, [mutuosEndosar, data, setMutuosEndosar]);
    const columnsResult = useMemo(() => COLUMNS_RESULT, []);

    const buildExportData = () => {
        return data.map((row) => {
            const mutuoEditado = mutuosEndosar.find((m) => m.id === row.id);
            const tasaEndosoValue = mutuoEditado?.tasaEndoso ?? row.tasaEndoso;
            const cuponesCortadosValue = mutuoEditado?.numCuponesCortados ?? row.numCuponesCortados;
            const fechaRemesaValue = mutuoEditado?.fechaRemesa ?? row.fechaRemesa;

            return {
                ...row,
                // Exportar como texto para preservar exactamente lo ingresado en las columnas editables.
                tasaEndoso: tasaEndosoValue.toString(),
                numCuponesCortados: cuponesCortadosValue.toString(),
                fechaRemesa: fechaRemesaValue,
            };
        });
    };

    const onExport = () => {
        const exportData = buildExportData();
        exportExcel(exportData as unknown as RowEndosoMasivo[], columns, "Endosos-Masivos");
    };

    const onSubmit = async (form: FiltroEndosoMasivo) => {
        console.log(form);
        const response = await buscarEndosos(form.fechaEndoso, form.institucion)
        setInversionista(form.institucion);
        setFechaEndoso(form.fechaEndoso);
        setData(response);
    }

    const onSubmitCalculo = () => {
        let totalMonto = 0;
        let tasaTotal = 0;
        let tasaTotalEmision = 0;
        console.log(mutuosEndosar.length);
        for (const mutuoEndosar of mutuosEndosar){
            console.log(mutuoEndosar);
            totalMonto += mutuoEndosar.montoCredito;
            tasaTotal += mutuoEndosar.tasaEndoso * mutuoEndosar.montoCredito;
            tasaTotalEmision += mutuoEndosar.tasaEmision * mutuoEndosar.montoCredito;
        }
        if (totalMonto !== 0){
            tasaTotal = tasaTotal / totalMonto;
            tasaTotalEmision = tasaTotalEmision / totalMonto;
        }
        const calculoEndosoMasivo : CalculoEndosoMasivo = {totalMonto: totalMonto, totalTasaEmision: tasaTotalEmision, totalTasaEndoso: tasaTotal}
        return calculoEndosoMasivo;
    }

    const onSave = () => {
        if (mutuosEndosar.length === 0){
            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: 'Debe seleccionar un mutuo para grabar',
            });
            return;
        }
        setModalConfirmacion({
            show: true,
            title: 'Grabar Operación',
            message: `¿Estás seguro que desea grabar?`,
            metodo: () => {
                handleOnSave();
            },
        });
    }

    const handleOnSave = async () => {
        const response: AxiosResponse<ListResponseDto<ResultOperacionEndoso>> = await grabarEndosos(fechaEndoso, inversionista, mutuosEndosar);
        if (response.status == 200 || response.status === 201){
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: 'Se grabó correctamente la operación'
            });
            setResultadosOperacion(response.data.items)
            setData([])
            setMutuosEndosar([])
        }
    }

    const onGeneracionMasiva = () => {
        navigate('/endosos/endosos-masivos/generacion-masiva')
    }

    useEffect(() => {
        if (resultadosOperacion.length > 0){
            setShowResult(true)
        }  
    }, [resultadosOperacion])
    
    return (
        <>
            <Suspense>
                <Breadcrumb items={breadcrumbItems} />
                <ConfirmationModal
                    onHide={() =>
                        setModalConfirmacion({ ...modalConfirmacion, show: false })
                    }
                    onConfirm={modalConfirmacion.metodo}
                    show={modalConfirmacion.show}
                    message={modalConfirmacion.message}
                    title={modalConfirmacion.title}
                />
                <ModalResultados 
                    open={showResult} 
                    onClose={() => setShowResult(false)} 
                    title='Resultados Operación Guardado Endoso'
                    data={resultadosOperacion} 
                    columns={columnsResult}
                    columnsExcel={columnsResult}
                    excelFileName='RESULTADOS-OPERACION-ENDOSO'
                />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <CustomAccordion
                            title='Filtros'
                            expandedDefault
                        >
                            <FormularioFiltroEndoso onSubmit={(e: FiltroEndosoMasivo) => {onSubmit(e)}}/>
                        </CustomAccordion>
                        <Box sx={{ mt: 4 }}>
                            <Tabla
                                data={data}
                                columns={columns}
                                   titulo={
                                    <TableHeader
                                        title=""
                                        buttonExport={
                                            <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                            <MButton
                                                type="button"
                                                variant="outlined"
                                                onClick={onExport}
                                                startIcon={<SummarizeTwoToneIcon />}
                                            >
                                                Exportar
                                            </MButton>
                                            </PermissionGuard>
                                        }
                                    />
                                }
                            />
                        </Box>
                        <CustomAccordion
                            title='Cálculos endoso masivo'
                            expandedDefault
                        >
                            <FormularioCalculoEndoso onCalculate={onSubmitCalculo} onSubmit={onSave} onGenerarMasivo={onGeneracionMasiva} isFormReseting={showResult}/>
                        </CustomAccordion>
                    </Paper>
                </Box>
            </Suspense>
        </>
    )
}